/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const VerticalCharging20Base = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M10 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v.5h-4V2Zm5 3H9a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h5.83l-.31 1.551c-.031.157-.04.307-.03.449H9a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v5.42a1.485 1.485 0 0 0-1.53.695l-.47.734V6a1 1 0 0 0-1-1Zm1.55 13.775h-2.325a.298.298 0 0 1-.153-.043.292.292 0 0 1-.093-.406l3.544-5.537a.285.285 0 0 1 .37-.107.282.282 0 0 1 .162.321l-.055.271-.75 3.751h2.325c.23 0 .37.255.246.449L17.98 20.35l-1.413 2.208-.29.452c-.174.271-.595.102-.531-.215l.804-4.021Zm-3.624-1.123.29-.452H9.25a.25.25 0 0 0-.25.25v2.3c0 .138.112.25.25.25h4.692c-1.045-.188-1.62-1.404-1.016-2.348Z" /></svg>);
const VerticalCharging20 = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={VerticalCharging20Base} {...rest} ref={ref} />);
export default VerticalCharging20;